<template>
  <section class="bg-[#F5EFE6]">
    <div class="px-4 py-12 mx-auto max-w-basic lg:px-10 lg:py-16 xl:pl-[137px] xl:pr-10">
      <div
        v-if="showDivider"
        class="flex gap-4 items-center py-[5px] mx-auto"
      >
        <div class="flex-1 h-px bg-[#E0D5C5]" aria-hidden="true" />
        <div
          class="flex justify-center items-center shrink-0 rounded-2xl border border-[#E0D5C5] size-8"
          aria-hidden="true"
        >
          <span class="rounded-full size-[14px] bg-[#F1574B]" />
        </div>
        <div class="flex-1 h-px bg-[#E0D5C5]" aria-hidden="true" />
      </div>

      <div :class="showDivider ? 'mt-10' : ''">
        <nuxt-img
          v-if="imageSrc"
          :src="imageSrc"
          :alt="imageAlt"
          width="962"
          height="450"
          format="webp"
          loading="lazy"
          class="object-cover w-full h-[450px] rounded-[15px]"
        />
        <div
          v-else
          class="w-full h-[450px] rounded-[15px] bg-[#2A2A2A]"
          aria-hidden="true"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  showDivider: {
    type: Boolean,
    default: true
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: 'Brain scan illustration highlighting neural activity'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Icon Divider Image',
  inputs: [
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: 'Brain scan illustration highlighting neural activity'
    }
  ]
})
</script>
